<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
<!------------------------------------------------------------------->
<!-- RANGE-TIME OPTIONS --------------------------------------------->
<!------------------------------------------------------------------->
        <v-btn-toggle
          v-model="rangeTime"
          mandatory
          color="primary"
          group
          dense
          class="elevation-3"
        >
          <v-btn
            v-for="(option, i) in dateOptions"
            :key="i"
            class="ma-0 caption font-weight-medium"
            @click="changeDates(option.value, option.start)"
          >
            {{ option.text }}
          </v-btn>
        </v-btn-toggle>
        <div class="elevation-3">
          <v-menu offset-y full-width>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                class="caption font-weight-medium grey--text text--darken-3"
              >
                {{ `${$t('dashboard.dates.from')} ${startDate}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              :locale="lang === 'es' ? 'es-mx' : lang === 'en' ? 'en-us' : 'pt-br'"
              no-title
              color="primary"
              :min="minDate"
              :max="$moment().format('YYYY-MM-DD')"
              @change="
                changeDates(
                  'customized',
                  $moment(startDate).unix(),
                  $moment(endDate)
                    .endOf('day')
                    .unix()
                )"
            />
          </v-menu>
          <v-menu offset-y full-width>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                class="caption font-weight-medium grey--text text--darken-3"
              >
                {{ `${$t('dashboard.dates.until')} ${endDate}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              :locale="lang === 'es' ? 'es-mx' : lang === 'en' ? 'en-us' : 'pt-br'"
              no-title
              color="primary"
              :min="minDate"
              :max="$moment().format('YYYY-MM-DD')"
              @change="
                changeDates(
                  'customized',
                  $moment(startDate).unix(),
                  $moment(endDate)
                    .endOf('day')
                    .unix()
                )"
            />
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <v-row>
<!------------------------------------------------------------------->
<!-- DONATIONS ------------------------------------------------------>
<!------------------------------------------------------------------->
      <!-- <v-col cols="12" sm="6">
        <v-card class="afrus-d-rounded-card" height="100%">
          <v-card-title class="subtitle-2 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.donations.title') }}
            <v-spacer></v-spacer>
            <v-tooltip
              v-if="moneyCode"
              left
              max-width="240"
              transition="slide-x-reverse-transition"
              color="black"
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">help_outline</v-icon>
              </template>
              <span>{{ $t('dashboard.message_conversion') }} <b>{{ moneyCode }}</b></span>
            </v-tooltip>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <BarChart
              :height="250"
              :chart-data="barDonations"
              :options="{
                scales: {
                  xAxes: [
                    {
                      ticks: {
                        callback: function(value, index, values) {
                          if(value.length > 10){
                            return value.slice(0,9) + '...'
                          }else{
                            return value
                          }
                        }
                      }
                    }
                  ],
                  yAxes: [
                    {
                      ticks: {
                        precision: 0,
                        beginAtZero: true
                      }
                    }
                  ]
                }
              }"
            />
          </v-card-text>
        </v-card>
      </v-col> -->
<!------------------------------------------------------------------->
<!-- LEADS ---------------------------------------------------------->
<!------------------------------------------------------------------->
      <!-- <v-col cols="12" sm="6">
        <v-card class="afrus-d-rounded-card" height="100%">
          <v-card-title class="subtitle-2 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.leads.title') }}
          </v-card-title>
          <v-divider />
          <v-card-text>
            <BarChart
              :height="250"
              :chart-data="barLeads"
              :options="{
                scales: {
                  xAxes: [
                    {
                      ticks: {
                        callback: function(value, index, values) {
                          if(value.length > 10){
                            return value.slice(0,9) + '...'
                          }else{
                            return value
                          }
                        }
                      }
                    }
                  ],
                  yAxes: [
                    {
                      ticks: {
                        precision: 0,
                        beginAtZero: true
                      }
                    }
                  ]
                }
              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row> -->
<!------------------------------------------------------------------->
<!-- STATUS AFRUS --------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.afrus_status') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium"
              :class=" afrusStatus ? 'success--text' : 'error--text' "
            >
              {{ afrusStatus ? 'Online' : 'Offline' }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- STATUS AFRUS DATA-BASE ----------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.afrus_db_status') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium"
              :class=" afrusDatabaseStatus ? 'success--text' : 'error--text' "
            >
              {{ afrusDatabaseStatus ? 'Online' : 'Offline' }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- STATUS UNOMI -------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.unomi_status') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium"
              :class=" unomiStatus ? 'success--text' : 'error--text' "
            >
              {{ unomiStatus ? 'Online' : 'Offline' }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- DATABASE SIZE -------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.afrus_db_size') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ afrusDatabaseSize }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- ACTIVE ORGANIZATIONS ------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.active_organizations') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ activeOrganizations }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- ACTIVE ACCOUNTS ------------------------------------------------>
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.active_accounts') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ activeAccounts }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- TRANSACTIONS --------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.transactions_success') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ transactions }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- TOTAL RENDERS -------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.total_renders') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalRenders }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- TOTAL VIEWS ---------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card" height="100%">
          <v-card-title class="subtitle-1 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.total_views') }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalViews }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
<!------------------------------------------------------------------->
<!-- CREATIONS ------------------------------------------------------>
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6">
        <v-card class="afrus-d-rounded-card">
          <v-card-title class="subtitle-2 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.creations') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <BarChart
              :height="250"
              :chart-data="barCreations"
              :options="{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        precision: 0,
                        beginAtZero: true
                      }
                    }
                  ]
                }
              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
<!------------------------------------------------------------------->
<!-- MEMBERS -------------------------------------------------------->
<!------------------------------------------------------------------->
      <v-col cols="12" sm="6">
        <v-card class="afrus-d-rounded-card">
          <v-card-title class="subtitle-2 font-weight-medium grey--text text--darken-2">
            {{ $t('dashboard.members') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <BarChart
              :height="250"
              :chart-data="barMembers"
              :options="{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        precision: 0,
                        beginAtZero: true
                      }
                    }
                  ]
                }
              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{ $t('general.loading')}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BarChart from '@/components/Charts/Bar'
import { mapActions, mapState } from 'vuex';

export default {
  name: 'home',
  components: {
    BarChart
  },
  async created() {
    await this.getStatus()
    // await this.inicialize(
    //   this.$moment()
    //     .startOf('month')
    //     .startOf('day')
    //     .unix()
    // )
  },
  watch: {
    startDate(newValue, oldValue) {
      if (newValue > this.endDate) {
        this.$noty.error(this.$t('general.error.invalid_range'))
        this.startDate = oldValue
      }
    },
    endDate(newValue, oldValue) {
      if (newValue < this.startDate) {
        this.$noty.error(this.$t('general.error.invalid_range'))
        this.endDate = oldValue
      }
    }
  },
  data () {
    return {
      isLoading: false,
      barDonations: {
        labels: [],
        datasets: [
          {
            label: this.$t('dashboard.donations.donations'),
            backgroundColor: '#EE602B',
            borderWidth: 1,
            data: []
          }
        ]
      },
      barLeads: {
        labels: [],
        datasets: [
          {
            label: this.$t('dashboard.leads.leads'),
            backgroundColor: '#EE602B',
            data: []
          }
        ]
      },
      barCreations: {
        labels: [],
        datasets: [
          {
            label: this.$t('dashboard.creations'),
            backgroundColor: '#EE602B',
            data: []
          }
        ]
      },
      barMembers: {
        labels: [],
        datasets: [
          {
            label: this.$t('dashboard.members'),
            backgroundColor: '#EE602B',
            data: []
          }
        ]
      },
      afrusStatus: 0,
      unomiStatus: 0,
      afrusDatabaseStatus: 0,
      afrusDatabaseSize: 0 + ' MB',
      activeAccounts: 0,
      activeOrganizations: 0,
      transactions: 0,
      totalRenders: 0,
      totalViews: 0,
      moneyCode: '',
      rangeTime: 3,
      selectCode: 'Tmt',
      startDate: this.$moment()
        .startOf('month')
        .startOf('day')
        .format('YYYY-MM-DD'),
      endDate: this.$moment().format('YYYY-MM-DD'),
    }
  },
  methods: {
    ...mapActions({
      getData: 'dashboard/getData',
      getDataAll: 'dashboard/getDataAll',
      getAfrusStatus: 'dashboard/getAfrusStatus',
      getUnomiStatus: 'dashboard/getUnomiStatus'
    }),
    async getStatus() {
      try {
        const {
          activeAccounts,//listo
          activeOrganizations,
          campaignsCreated,//listo
          leadFormsCreated,//listo
          donationFormsCreated,//listo
          leads,//listo
          donors,//listo
          recurrents,//listo
          transactions,//listo
          totalRenders,//
          afrusDatabaseSize,//listo
          totalViews//
        } = (await this.getDataAll()).data

        const afrusStatus = await this.getAfrusStatus()
        const unomiStatus = await this.getUnomiStatus()

        this.activeAccounts = activeAccounts ? activeAccounts : 0
        this.activeOrganizations = activeOrganizations ? activeOrganizations : 0
        this.afrusDatabaseSize = afrusDatabaseSize ? afrusDatabaseSize : 0 + 'MB'
        this.afrusDatabaseStatus = afrusDatabaseSize ? 1 : 0
        this.afrusStatus = afrusStatus ? afrusStatus : 0
        this.unomiStatus = unomiStatus ? unomiStatus : 0
        this.transactions = transactions ? transactions : 0
        this.totalRenders = totalRenders ? totalRenders : 0
        this.totalViews = totalViews ? totalViews : 0
        const barCreationsLabels = [this.$t('dashboard.campaigns'), this.$t('dashboard.leads_f'), this.$t('dashboard.giving_f')]
        this.barCreations = {
              labels: barCreationsLabels,
              datasets: [
                {
                  label: this.$t('dashboard.creations'),
                  data: [campaignsCreated, leadFormsCreated, donationFormsCreated],
                  backgroundColor: '#EE602B',
                  borderColor: '#EE602B',
                  fill: false
                }
              ]
            }
        const barMembersLabels = [this.$t('dashboard.leads_g'), this.$t('dashboard.donors_g'), this.$t('dashboard.reccurent_g')]
        this.barMembers = {
              labels: barMembersLabels,
              datasets: [
                {
                  label: this.$t('dashboard.members'),
                  data: [leads, donors, recurrents],
                  backgroundColor: '#EE602B',
                  borderColor: '#EE602B',
                  fill: false
                }
              ]
            }
      } catch (error) {

      }
    },
    async inicialize(start, end = this.$moment().endOf('day').unix()) {
      if (this.startDate > this.endDate) {
        return
      } else {
        try {
          this.isLoading = true
          const {
            top5organizationsAmount,
            top5organizationsLeads,
            user_currency
          } = (await this.getData({ id: this.user.organization.id, start, end })).data
          this.isLoading = false
          this.moneyCode = user_currency
          const donationsLabel = []
          const donationsValues = []
          top5organizationsAmount.map((el, i) => {
            donationsLabel.push(el.name)
            donationsValues.push(el.user_conversion_amount)
          })

          this.barDonations = {
            labels: donationsLabel,
            datasets: [
              {
                label: this.$t('dashboard.donations.donations'),
                data: donationsValues,
                backgroundColor: '#EE602B',
                borderColor: '#EE602B',
                fill: false
              }
            ]
          }

          const leadsLabel = []
          const leadsValue = []
          top5organizationsLeads.map((el, i) => {
            leadsLabel.push(el.name)
            leadsValue.push(el.total_leads)
          })
          this.barLeads = {
            labels: leadsLabel,
            datasets: [
              {
                label: this.$t('dashboard.leads.leads'),
                data: leadsValue,
                backgroundColor: '#EE602B',
                borderColor: '#EE602B',
                fill: false
              }
            ]
          }

          this.startDate = this.$moment.unix(start).format('YYYY-MM-DD')
          this.endDate = this.$moment.unix(end).format('YYYY-MM-DD')
        } catch (err) {
          console.log(err)
          this.isLoading = false
          this.$noty.error(this.$t('dashboard.error'))
        }
      }
    },
    changeDates(code, start, end = null) {
      const startDate = !start ? this.$moment(this.startDate).unix() : start
      const endDate = !end
        ? this.$moment(this.endDate)
            .endOf('day')
            .unix()
        : end
      if (code === 'customized') {
        this.selectCode = code
        this.rangeTime = 7
        // this.inicialize(startDate, endDate)
      } else if (this.selectCode !== code) {
        this.selectCode = code
        // this.inicialize(startDate)
      }
    },
  },
  computed: {
    ...mapState({
      creationDateOrg: ({ auth: { user } }) => user,
      lang: ({ auth: { locale } }) => locale,
      user: ({ auth: { user } }) => user
    }),
    dateOptions() {
      if (this.creationDateOrg.organization) {
        return [
          {
            text: '1w',
            value: '1w',
            start: this.$moment()
              .subtract(6, 'days')
              .startOf('day')
              .unix()
          },
          {
            text: '4w',
            value: '4w',
            start: this.$moment()
              .subtract(1, 'month')
              .add(1, 'day')
              .startOf('day')
              .unix()
          },
          {
            text: '1y',
            value: '1y',
            start: this.$moment()
              .subtract(1, 'year')
              .add(1, 'day')
              .startOf('day')
              .unix()
          },
          {
            text: 'mtd',
            value: 'mtd',
            start: this.$moment()
              .startOf('month')
              .unix()
          },
          {
            text: 'qtd',
            value: 'qtd',
            start: this.$moment()
              .startOf('quarter')
              .unix()
          },
          {
            text: 'ytd',
            value: 'ytd',
            start: this.$moment()
              .startOf('year')
              .unix()
          },
          {
            text: this.$t('dashboard.dates.all'),
            value: 'All',
            start: this.$moment(this.creationDateOrg.organization.created_at).unix()
          },
          {
            text: this.$t('dashboard.dates.custom'),
            value: 'customized',
            start: null
          }
        ]
      }
      return ''
    },
    minDate() {
      if (this.creationDateOrg.organization) {
        const creationDateOrg = this.$moment
          .unix(this.creationDateOrg.organization.created_at)
          .format('YYYY-MM-DD')
        const oneYearAgo = this.$moment()
          .subtract(1, 'year')
          .add(1, 'day')
          .startOf('day')
          .format('YYYY-MM-DD')
        return creationDateOrg < oneYearAgo ? creationDateOrg : oneYearAgo
      }
      return ''
    }
  }
}
</script>
